export default "__VITE_ASSET__B$6CiKpf__"